import * as THREE from "three";

import gaussianVertexShader from "../shaders/gaussian.vert";
import gaussianFragmentShader from "../shaders/gaussian.frag";

export function createGaussianMaterial(textures) {
  if (!textures) {
    return null;
  }

  return new THREE.ShaderMaterial({
    vertexShader: gaussianVertexShader,
    fragmentShader: gaussianFragmentShader,

    transparent: true,
    depthTest: true,
    depthWrite: false,
    side: THREE.DoubleSide,

    uniforms: {
      viewport: {
        value: new THREE.Vector2(1, 1),
      },
      globalScale: {
        value: 1,
      },
      globalOpacity: {
        value: 1,
      },
      alphaCutoff: {
        value: 0.01,
      },
      gaussianCenterOpacityTexture: {
        value: textures.centerOpacity,
      },
      gaussianScaleTexture: {
        value: textures.scale,
      },
      gaussianRotationTexture: {
        value: textures.rotation,
      },
      gaussianColorTexture: {
        value: textures.color,
      },
      gaussianTextureWidth: {
        value: textures.width,
      },
      gaussianTextureHeight: {
        value: textures.height,
      },
    },
  });
}

export function updateGaussianMaterial(
  material,
  { splatScale, opacity, alphaCutoff },
) {
  if (!material) {
    return;
  }

  material.uniforms.globalScale.value = splatScale;
  material.uniforms.globalOpacity.value = opacity;
  material.uniforms.alphaCutoff.value = alphaCutoff;
}

export function updateGaussianViewport(material, renderer) {
  if (!material || !renderer) {
    return null;
  }

  const size = new THREE.Vector2();

  renderer.getDrawingBufferSize(size);
  material.uniforms.viewport.value.copy(size);

  return size;
}

export function disposeGaussianMaterial(material) {
  material?.dispose();
}
